export const returnPopupMixin = {
    methods: {
        /**
         * Creates a return popup to allow user to enter product return detail
         * @function
         * @param {ReturnPopup} ReturnPopupItem Return popup object product, batch, serial Number, and document text.
         * @param {String} [returnPopupRef=bo_return_popup] Name of the return popup component.
         */
        async boReturnPopup(
            ReturnPopupItem,
            returnPopupRef = "bo_return_popup"
        ) {
            console.log(this.$refs);
            const confirm = await this.$refs[returnPopupRef].activate(
                ReturnPopupItem.returnPopup.product,
                ReturnPopupItem.returnPopup.batch,
                ReturnPopupItem.returnPopup.serialNumber,
                ReturnPopupItem.returnPopup.document
            );
        },
    },
};

export default returnPopupMixin;
